import React from 'react'
// Local
import {
  CONDITION,
  shouldRenderReskin2025
} from '../../../constant'
import { EncounterConditionDisplay } from '../../authenticated/types'
import If from '../../common/if'
import ReveleerButton from '../../common/ReveleerButton'

/**
 * Provides a view of encounter condition practitioner tags with the option for
 * the provider to undo the selected response
 * @param condition Condition entity
 * @param hccChild True if the condition is a member of an HCC group
 * @param onConditionAction Callback for condition action
 *        Arguments action, condition
 */

type Props = {
  condition: EncounterConditionDisplay
  onConditionAction: (
    action: any,
    condition: EncounterConditionDisplay[]
  ) => void
}

function PhysicianConditionTags(
  props: Props
): JSX.Element | null {
  const {
    condition: conditionProp,
    onConditionAction: onConditionActionProp
  } = props
  const onClickUndo = () => {
    const action = CONDITION.ACTION.UPDATE_PRACTITIONER_TAGS
    if (conditionProp.practitionerTags) {
      conditionProp.practitionerTags.practitionerResponseCode = null
      onConditionActionProp(
        action,
        [ conditionProp ]
      )
    }
  }

  const renderPractitionerTags = () => {
    // TODO - sboles - confirm that it is safe to remove the Undo
    //      - and then clean out undo support
    const shouldAllowUndo = false
    return (
      <span>
        <span className="italic">
          <span>Marked as:</span>
          <span>&nbsp;</span>
          <span className="bold">
            {
              conditionProp &&
              conditionProp.practitionerTags &&
              conditionProp.practitionerTags.practitionerResponseCode
            }
          </span>
          <span>&nbsp;</span>
          <span>by Provider</span>
        </span>
        <If isTrue={ shouldAllowUndo }>
          <span>
            <span>&nbsp;|&nbsp;</span>
            <If isTrue={ shouldRenderReskin2025 }>
              <ReveleerButton
                buttonLabel="Undo"
                buttonSize="small"
                buttonType="dismissive"
                id="read-condition-undo-button"
                isDisabled={ false }
                onClick={ onClickUndo }
                type="button"
              />
            </If>
            <If isTrue={ !shouldRenderReskin2025 }>
              <span
                className="linkable"
                onClick={ onClickUndo }>
                Undo
              </span>
            </If>
          </span>
        </If>
      </span>
    )
  }

  return conditionProp.practitionerTags
    ? renderPractitionerTags()
    : null
}

export default PhysicianConditionTags
